/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Thanks_Meta_TitleInputs */

const ja_playdata_thanks_meta_title = /** @type {(inputs: Playdata_Thanks_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ありがとうございます`)
};

const en_playdata_thanks_meta_title = /** @type {(inputs: Playdata_Thanks_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank You`)
};

/**
* | output |
* | --- |
* | "Thank You" |
*
* @param {Playdata_Thanks_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_thanks_meta_title = /** @type {((inputs?: Playdata_Thanks_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Thanks_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_thanks_meta_title(inputs)
	return en_playdata_thanks_meta_title(inputs)
});